import {TStoreAction} from './store-action.type';

//#region INTERFACE IStoreActionSetting
export interface IStoreActionSetting<T = unknown> {
  settings?: {
    [storeId: string]: T;
  };
  storeAction?: TStoreAction;
}

//#endregion